import { SimpleSidebarHeader } from "@volca/ui/components/ui/simple-sidebar";
import { formatMoneyCents } from "@/core/utils/money";
import type { StAdjustmentTechnicianGroup } from "./types";

interface TechnicianSidebarHeaderProps {
  group: StAdjustmentTechnicianGroup;
  onClose: () => void;
}

export const TechnicianSidebarHeader = ({
  group,
  onClose,
}: TechnicianSidebarHeaderProps) => (
  <SimpleSidebarHeader
    title={
      group.technicianName ??
      (group.employee_id == null
        ? "Unknown technician"
        : `Technician #${group.employee_id}`)
    }
    description={
      <>
        {group.technicianName && `#${group.employee_id} · `}
        {group.pending} to push ·{" "}
        {formatMoneyCents(group.pending_amount_cents) ?? "$0"}
        {group.pushed > 0 && ` · ${group.pushed} already pushed`}
      </>
    }
    onClose={onClose}
  />
);
